import React from 'react';
import headerUnderline from '../assets/figma/header-underline.svg';
import shieldCheck from '../assets/figma/shield-check.svg';

const certifications = [
   {
    title: 'AWS Certified Cloud Practitioner (CLF-C02)',
    issuer: 'Amazon Web Services',
    year: '2026',
    href: 'https://www.credly.com/badges/62ff63c4-17d0-4176-bf73-2a9c74a98424/',
  },
  {
    title: 'AWS Certified AI Practitioner (AIF-C01)',
    issuer: 'Amazon Web Services',
    year: '2026',
    href: 'https://www.credly.com/badges/91f39eb8-2b82-4072-9f3e-38debc6bcc59',
  },
  {
    title: 'AWS Academy Machine Learning Foundations',
    issuer: 'Amazon Web Services',
    year: '2025',
    href: 'https://www.credly.com/badges/19561516-9309-4fd0-8168-0f5e17706c9e',
  },
  {
    title: 'The Joy of Computing Using Python - NPTEL',
    issuer: 'National Programme on Technology Enhanced Learning (NPTEL)',
    year: '2024',
    href: 'https://archive.nptel.ac.in/content/noc/NOC25/SEM1/Ecertificates/106/noc25-cs69/Course/NPTEL25CS69S95230114204447335.pdf',
  },
];

const Certifications = () => (
  <section className="certifications-section" id="certifications-section">
    <div className="certifications-content">
      <header className="certifications-header">
        <div className="certifications-kicker">
          <span className="certifications-kicker-dot" />
          <span>Credentials</span>
        </div>
        <h2>Certifications</h2>
        <img className="certifications-underline" src={headerUnderline} alt="" aria-hidden="true" />
      </header>

      <div className="certifications-list">
        {certifications.map((certification) => (
          <a className="certification-item" href={certification.href} target="_blank" rel="noreferrer" key={certification.title}>
            <div className="certification-info">
              <div className="certification-icon-wrap">
                <img src={shieldCheck} alt="" aria-hidden="true" />
              </div>
              <div className="certification-title-issuer">
                <h3>{certification.title}</h3>
                <p>{certification.issuer}</p>
              </div>
            </div>
            <span className="certification-year">{certification.year}</span>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default Certifications;
